import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { useAuth } from '../context/AuthContext';
import { countries } from '../data/countries';
import SafeIcon from '../common/SafeIcon';
import { FiGlobe, FiUser, FiPlus, FiLogOut, FiShield, FiActivity } from 'react-icons/fi';
import { cn } from '../utils/cn';

export default function Navbar() {
  const { lang, t, toggleLang } = useLang();
  const { user, logout, lockedCountries } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="sticky top-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <SafeIcon icon={FiGlobe} className="text-3xl text-lime-400 group-hover:rotate-12 transition-transform" />
            <span className="font-black text-xl tracking-tighter uppercase italic text-white group-hover:text-glow">
              Vote<span className="text-lime-400">Nations</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/chances"
              className="px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-slate-300 border border-slate-800 rounded-lg hover:border-lime-400/50 hover:text-white transition-colors"
            >
              {t('miracle_calculator')}
            </Link>
            {lockedCountries.length > 0 && (
              <div className="flex items-center gap-2 px-3 py-1 bg-slate-900 border border-slate-800 rounded-full">
                <SafeIcon icon={FiShield} className="text-lime-400 text-xs" />
                <span className="text-[10px] font-black uppercase text-slate-500 tracking-wider">
                  {t('voting_as')}:
                </span>
                <div className="flex gap-1">
                  {lockedCountries.map(code => (
                    <span key={code} className="text-[10px] font-bold text-white bg-slate-800 px-1.5 rounded" title={countries.find(c => c.code === code)?.name}>
                      {code}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="flex items-center gap-3 sm:gap-4">
            <Link
              to="/chances"
              className="md:hidden flex items-center gap-1.5 px-2.5 py-1.5 border border-slate-800 rounded-lg text-slate-300 hover:border-lime-400/50 hover:text-white transition-colors"
              title={t('miracle_calculator')}
            >
              <SafeIcon icon={FiActivity} className="text-lime-400 shrink-0" />
              <span className="hidden sm:inline text-[10px] font-bold uppercase tracking-wide leading-tight">
                {t('miracle_calculator')}
              </span>
            </Link>
            <button onClick={toggleLang} className="px-3 py-1 rounded-full bg-slate-800 text-xs font-bold uppercase hover:bg-slate-700 transition-colors">
              {lang === 'en' ? 'ES' : 'EN'}
            </button>
            
            {user ? (
              <div className="flex items-center gap-3">
                <Link to="/profile" className="hidden sm:flex items-center gap-1 px-3 py-2 border border-slate-700 rounded font-bold hover:bg-slate-800 transition-colors">
                  <SafeIcon icon={FiUser} />
                  <span>{t('profile')}</span>
                </Link>
                <Link to="/create" className="hidden sm:flex items-center gap-1 px-4 py-2 bg-lime-400 text-slate-950 font-bold rounded hover:bg-lime-300 transition-colors">
                  <SafeIcon icon={FiPlus} />
                  <span>{t('create_map')}</span>
                </Link>
                <button onClick={async () => { await logout(); navigate('/'); }} className="p-2 text-slate-400 hover:text-white transition-colors">
                  <SafeIcon icon={FiLogOut} size={20} />
                </button>
              </div>
            ) : (
              <Link to="/login" className="flex items-center gap-2 px-4 py-2 border border-slate-700 rounded font-bold hover:bg-slate-800 transition-colors">
                <SafeIcon icon={FiUser} />
                <span className="hidden sm:inline">{t('login')}</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}